import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f93b32e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/logo.png",
    alt: "weas"
  })
], -1))
const _hoisted_4 = { class: "app" }
const _hoisted_5 = { class: "header-center" }
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = {
  key: 0,
  class: "alerts"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-bell fas" }, null, -1))
const _hoisted_9 = { class: "user" }
const _hoisted_10 = { class: "el-dropdown-link" }
const _hoisted_11 = { class: "hidden-sm-and-down" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "fas el-icon-caret-down" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Aceptar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_user_pass_form = _resolveComponent("user-pass-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.app), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("div", { class: "point" }, _toDisplayString(_ctx.samplingPointName), 513), [
          [_vShow, _ctx.samplingPointName]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_ctx.isAppDemo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_badge, {
                hidden: !_ctx.notifications,
                value: _ctx.notifications,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToAlerts())),
                class: _normalizeClass(_ctx.notificationCss),
                title: _ctx.$t('info.notificationNumber', { number: _ctx.notifications, minutes: 60 })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, null, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["hidden", "value", "class", "title"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_dropdown, {
            class: "user-name",
            trigger: "click",
            onCommand: _ctx.handleCommand
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  (_ctx.entorno)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showChangePasswordModal = true)),
                        class: "btnLogout"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.changePassword")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    onClick: _ctx.handleCommand,
                    class: "btnLogout"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("btn.logout")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.username), 1),
                _hoisted_12
              ])
            ]),
            _: 1
          }, 8, ["onCommand"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "Cambiar contraseña",
      modelValue: _ctx.showChangePasswordModal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showChangePasswordModal) = $event)),
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showChangePasswordModal = false))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeUserPassword()))
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_user_pass_form, { ref: "userPassForm" }, null, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}